import { DropdownController } from './dropdown-controller.js';

let isInitialized = false;
let controllers = [];
let teardownCallbacks = [];

/**
 * Initialize dropdown toggle behavior for dashboard filters and
 * manage the clear-search button visibility.
 *
 * @param {object} dashboard Instance of CollectionsDashboard (optional).
 */
export function initFilterDropdowns(dashboard = null) {
    if (isInitialized) {
        return;
    }

    const dropdownPairs = [
        { buttonId: 'tags-filter-btn', menuId: 'tags-filter-menu' },
        { buttonId: 'visibility-filter-btn', menuId: 'visibility-filter-menu' },
        { buttonId: 'sort-filter-btn', menuId: 'sort-filter-menu' },
    ];

    controllers = dropdownPairs
        .map(({ buttonId, menuId }) => {
            const button = document.getElementById(buttonId);
            const menu = document.getElementById(menuId);
            if (!button || !menu) {
                return null;
            }

            return new DropdownController(button, menu, {
                closeOthers: true,
            });
        })
        .filter(Boolean);

    teardownCallbacks.push(() => {
        controllers.forEach((controller) => controller.destroy());
        controllers = [];
    });

    initializeSearchClearButton(dashboard);

    isInitialized = true;
}

function initializeSearchClearButton(dashboard) {
    const searchInput = dashboard?.searchInput || document.getElementById('collections-search');
    const clearButton = document.getElementById('clear-search');

    if (!searchInput || !clearButton) {
        return;
    }

    const toggleClearButton = () => {
        if (searchInput.value.trim().length > 0) {
            clearButton.classList.remove('hidden');
            clearButton.classList.add('flex');
        } else {
            clearButton.classList.add('hidden');
            clearButton.classList.remove('flex');
        }
    };

    const handleClearClick = () => {
        searchInput.value = '';
        toggleClearButton();
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    };

    searchInput.addEventListener('input', toggleClearButton);
    clearButton.addEventListener('click', handleClearClick);

    teardownCallbacks.push(() => {
        searchInput.removeEventListener('input', toggleClearButton);
        clearButton.removeEventListener('click', handleClearClick);
    });

    toggleClearButton();
}

export function destroyFilterDropdowns() {
    teardownCallbacks.forEach((teardown) => teardown());
    teardownCallbacks = [];
    controllers = [];
    isInitialized = false;
}
